module.exports = __webpack_public_path__ + "static/media/default.63a19caf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/mono/default.svg
// module id = 489
// module chunks = 0